import classNames from 'classnames';
import React from 'react';

import BaseList from 'ui/legacy/List';

import { listWrapperStyle } from './UI';
import InfiniteScroll from '../InfiniteScroll';

/**
 * @template T
 * @typedef {{
 *  dataSource: Array<T>,
 *  renderItem: (data: T) => React.ReactNode,
 *  apiError?: boolean,
 *  hasMore?: boolean,
 *  loading?: boolean,
 *  onLoadMore: () => void,
 *  className?: import('classnames').Argument;
 * }} ListProps
 */

/** @type {React.FC<ListProps>} */
const List = ({ onLoadMore, hasMore, apiError, loading, dataSource, renderItem, className }) => (
  <div className={classNames(listWrapperStyle, className, 'border rounded border-grey overflow-auto p-2')}>
    <InfiniteScroll loadMore={onLoadMore} hasMore={hasMore} apiError={apiError} useParent>
      <BaseList rowKey="id" loading={loading} dataSource={dataSource} renderItem={renderItem} />
    </InfiniteScroll>
  </div>
);

export default List;
